var path = 'scripts/views/components/cycle-receipt-delete-popup.html';
var html = "<div class=\"popover-content\" id=\"confirmation\" style=\"width:250px\">\n    <a ng-click=\"$ctrl.deleteReceipt()\" data-apply=\"confirmation\"\n       class=\"btn btn-sm btn-default mrs delete-receipt\">\n        {{\"popover.Delete\" | translate}}</a>\n    <a ng-click=\"$ctrl.togglePopover()\" data-dismiss=\"confirmation\" class=\"inverse-link cancel-delete\">\n        {{\"popover.Cancel\" | translate}}\n    </a>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/cycle-receipt-delete-popup.html
// module id = 310
// module chunks = 0